function initialsOf(name: string): string {
  const words = name.split(/\s+/).filter(Boolean);

  return words.slice(0, 2).map(word => word[0]).join('').toUpperCase();
}

/**
 * Holds the other participant's place before they arrive. An empty corner reads
 * as "nobody is coming"; a tile with their name reads as "they are not here
 * yet", which is what is actually true — the call is almost always the customer
 * waiting out the account manager's last minute on a previous appointment.
 */
export default function WaitingParticipantTile({ name }: { name: string }) {
  return (
    <div className="relative flex aspect-portrait w-24 flex-col items-center justify-center gap-2 overflow-hidden rounded-xl bg-gray-800 px-2 shadow-lg ring-1 ring-white/20 md:aspect-video md:w-full">
      <span className="flex size-10 shrink-0 animate-pulse items-center justify-center rounded-full bg-gray-700 text-base font-bold leading-none text-gray-300">
        {initialsOf(name)}
      </span>
      {/* The phone tile is 96px wide, too narrow to name anybody without
          truncating them into nonsense. */}
      <span className="truncate text-center text-xs text-gray-400 md:hidden">
        Waiting
      </span>
      <span className="hidden truncate text-center text-xs text-gray-400 md:block">
        Waiting for {name}
      </span>
    </div>
  );
}
